
/**
 * @param props
 */

export default (props) => {
    return {
        mounted() {

            let intersect = new IntersectionObserver((entries) => {
                entries.forEach(function(entry) {
                    if (entry.intersectionRatio > 0) {
                        intersect.unobserve(entry.target);
                        fetch(window.variables.native.trackViewUrl + '?' + new URLSearchParams({
                            id: props.id,
                        })).then(r => {});
                    }
                });
            });
            intersect.observe(this.$refs.nativeElement);

        },
        click() {
            fetch(window.variables.native.trackClickUrl + '?' + new URLSearchParams({
                id: this.id,
            })).then(r => {});
        }
    }
};